import React, { useState, useEffect } from 'react';
import { LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import { withStyles } from '@mui/styles';


import { baseDateTimeFormatting, convertUtcToDate } from '../../common/helper';
import { colors } from '../../helpers/colors';
import Compdirection from '../../common/themes/CompDirection';

const CssTextField = withStyles({
  root: {
    '& .muiltr-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '15px',
    },
    '& label.Mui-focused': {
      color: colors.primary,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: colors.primary,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#0000003b',
      },
      '&:hover fieldset': {
        borderColor: colors.primary,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.primary,
      },
    },
  },
})(TextField);

// Define props type
interface TimePickerInputProps {
  label?: string;
  value?: Date | null;
  error?: boolean;
  helperText?: string;
  onChange?: (date: Date | null) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  defaultValue?: Date | null;
  timezoneOffset?: any;
  supportUTC?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  className?: string;
  width?: any;
}

export const TimePickerInput: React.FC<TimePickerInputProps> = ({
  label,
  value = null,
  error,
  helperText,
  onChange,
  onBlur,
  placeholder,
  disabled,
  defaultValue,
  timezoneOffset,
  supportUTC = true,
  variant = 'standard',
  className = 'w-[100px]',
  width
}) => {
  const [time, setTime] = useState<Date | null>(null);

  const handleChange = (date: Date | null) => {
    onChange?.(date);
    setTime(date);
  };

  useEffect(() => {
    if (defaultValue && supportUTC) {
      const convertedTime: any = convertUtcToDate(
        defaultValue,
        baseDateTimeFormatting,
        timezoneOffset,
        false
      );
      setTime(convertedTime);
    } else if (defaultValue && !supportUTC && !time) {
      setTime(defaultValue);
    }
  }, [timezoneOffset, defaultValue, supportUTC]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Compdirection>
        <MobileTimePicker
          label={label}
          componentsProps={{
            actionBar: {
              actions: ['clear', 'cancel', 'accept'],
            },
          }}
          value={time || value}
          disabled={disabled}
          onAccept={handleChange}
          onChange={(newValue) => setTime(newValue)}
          renderInput={(params) => (
            <CssTextField
              {...params}
              variant={variant}
              error={error}
              className={`h-fit ${className}`}
              InputProps={{
                className: `!text-sm !font-bold !text-primary ${className}`,
              }}
              placeholder={placeholder}
              helperText={helperText}
              onBlur={onBlur}
              focused={!!value}
              style={{
                width: width
              }}
            />
          )}
        />
      </Compdirection>
    </LocalizationProvider>
  );
};
